import React, { Component } from 'react'
import VMasker from 'vanilla-masker'
import { reverseString, ensureEnglishNumber } from '../../helpers/utility'
import { toPersianDigit } from '../../helpers/nums'

export default class extends Component {
  state = {
    value: '',
    maskedValue: ''
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.value && nextProps.value !== this.props.value) {
      this.updateState({
        value: nextProps.value,
        shouldUpdateParent: false
      })
    }
  }

  maskMoney = rawValue =>
    reverseString(
      VMasker.toPattern(reverseString(rawValue), '999,999,999,999,999,999')
    )

  unMaskMoney = rawValue => rawValue.replace(/,/g, '')

  onInputChange = ({ target: { value } }) => {
    this.updateState({
      value,
      shouldUpdateParent: true
    })
  }

  getInputValue = () => toPersianDigit(this.state.maskedValue)

  formatPriceToShow = price => toPersianDigit(this.maskMoney(String(price)))

  updateState = ({ value, shouldUpdateParent }) => {
    const maskedValue = this.maskMoney(ensureEnglishNumber(value))
    this.setState({ maskedValue: maskedValue }, () => {
      shouldUpdateParent && this.props.onChange(this.unMaskMoney(maskedValue))
    })
  }

  handleInputChange = event => this.updateValue(event.target.value)

  // componentWillUpdate = nextProps => {
  //   if (nextProps.value && nextProps.value !== this.props.value)
  //     this.updateValue(nextProps.value)
  // }

  render() {
    return (
      <input
        {...this.props}
        type="text"
        className="money-input"
        onChange={this.onInputChange}
        value={this.getInputValue()}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/MoneyInput.js